<template>
  <form class="searcher-form" @submit.prevent="searcher()">
    <div class="input-field">
      <label for="search"> {{ label }} </label>
      <input class="input-with-btn" type="text" id="search" ref="input" v-bind:value="value"
             v-on:input="updateValue($event.target.value)">
      <button type="submit" class="btn btn-flat btn-search tooltipped"
              data-delay="50" :data-tooltip="dataTooltip">
        <i :class="buttonIcon"></i>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: [ 'label', 'value', 'dataTooltip', 'buttonIcon' ],
  methods: {
    searcher () {
      this.$emit('submitAction')
    },
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
.searcher-form {
  .input-field label {
    margin-top: 0;
  }
  .btn-search {
    position: absolute;
    top: 0%;
    right: 0%;
    height: 3.5em;
    width: 3.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 7%;
  }
}
</style>



// WEBPACK FOOTER //
// searcher.vue?743aa51c